import { registerComponent } from '@gig/magic-common';
import RealityCheckComponent from './reality-check.vue.js';

var RealityCheck = registerComponent(RealityCheckComponent);

export { RealityCheck };
